//#region imports
import customAxios from '../../utils/customAxios';
import React, { useState, useEffect } from 'react';

import { DataGridPro } from '@mui/x-data-grid-pro';

import { useNavigate } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';

import { Stack } from '@mui/system';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAdd,
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
} from '@fortawesome/free-solid-svg-icons';

import { ContentCopyOutlined } from '@mui/icons-material';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import { toast } from 'react-toastify';
import { useTranslationHook } from '../../hooks/UseTranslationHook';
import { GlobalVariables } from '../../globalVar';

import { faChevronLeft } from '@fortawesome/sharp-regular-svg-icons';
import ModalR from '../Modal/Create/ModalR';
import { getToast } from '../../utils/toastConfig';
import { useTableLocale } from '../../hooks/useTableLocale';

library.add(
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble
);

//#endregion

export const Reports = ({ selectedQForReports, manageReturnToAllQ }) => {
  const [reportsData, setReportData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [modalRShow, setModalRShow] = useState(false);

  const {
    viewReportTooltip,
    addReportBtn,
    reportNameColumn,
    reportDescColumn,
    detailString,
    noReportsLabel,
  } = useTranslationHook();

  const navigate = useNavigate();

  const endpoint = `${GlobalVariables.getURL()}getReports/${selectedQForReports}`;

  const locale = useTableLocale();

  /**
   * Function to obtain information from all reports
   * @returns {any} Data from all reports to populate the table
   */
  const getData = async () => {
    setIsLoading(true);

    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      const allRData = response.data.reports.map((report) => {
        return {
          ...report,
        };
      });
      setReportData(allRData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  /**
   * Function to duplicate the selected report
   * @param {Object} reportInfo - Object of the selected row
   * @param {string} reportInfo.id - The ID of the report
   */
  function handleDuplicate(reportInfo) {
    const reportId = reportInfo.id;
    customAxios
      .post(`${GlobalVariables.getURL()}duplicateReport/${reportId}`)
      .then(
        (response) => {
          getToast({
            status: 'success',
            title: 'Reporte duplicado exitosamente en la base de datos.',
          });
          getData();
        },
        (error) => {
          console.error('Error al duplicar el reporte', error);
          getToast({
            status: 'error',
            title: 'Error al duplicar reporte. Vuelve a intentarlo.',
          });
        }
      );
  }

  const actionColumn = [
    {
      field: 'action',
      headerName: detailString,
      width: 160,
      renderCell: (params) => {
        return (
          <div className='cellAction'>
            <Tooltip title={viewReportTooltip} arrow>
              <button
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  marginTop: '5px',
                }}
                onClick={() => {
                  console.log(params.row.formatted_template);
                  localStorage.setItem(
                    'reportBuilderTemplate',
                    params.row.formatted_template
                  );
                  localStorage.setItem('reportBuilderReportId', params.row.id);
                  navigate('/reportsBuilder');
                }}
              >
                <VisibilityOutlinedIcon className='detail-icons' />
              </button>
            </Tooltip>
            <Tooltip title='Duplicar' arrow>
              <button
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  marginTop: '5px',
                }}
                onClick={() => handleDuplicate(params.row)}
              >
                <ContentCopyOutlined className='detail-icons' />
              </button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  // Columns
  const allRColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 70,
    },
    {
      field: 'name',
      headerName: reportNameColumn,
      width: 400,
    },
    {
      field: 'description',
      headerName: reportDescColumn,
      width: 330,
    },
    // Map through all columns and add default renderCell if not already defined
  ].map((col) =>
    col.renderCell
      ? col
      : {
          ...col,
          renderCell: (params) =>
            params.row[col.field] ? params.row[col.field] : '-',
        }
  );

  return (
    <div className='full-container'>
      <div className='full-datatables-container'>
        <div style={{ marginTop: '1%', marginBottom: '1%' }}>
          <IconButton
            size='medium'
            className='back-icon-container'
            onClick={manageReturnToAllQ}
          >
            <FontAwesomeIcon icon={faChevronLeft} className='back-icon' />
          </IconButton>

          <button className='add-button' onClick={() => setModalRShow(true)}>
            {addReportBtn} <FontAwesomeIcon icon={faAdd} />
          </button>
        </div>

        <ModalR
          show={modalRShow}
          onHide={() => setModalRShow(false)}
          getReports={getData}
          questionnaireId={selectedQForReports}
        />

        <DataGridPro
          localeText={locale.components.MuiDataGrid.defaultProps.localeText}
          pagination
          loading={isLoading}
          initialState={{
            sorting: {
              sortModel: [{ field: 'id', sort: 'desc' }],
            },
            columns: {
              columnVisibilityModel: {
                id: false,
              },
            },
            pinnedColumns: { right: ['action'] },
          }}
          rows={reportsData}
          columns={allRColumns.concat(actionColumn)}
          disableSelectionOnClick
          slots={{
            noRowsOverlay: () => (
              <Stack height='100%' alignItems='center' justifyContent='center'>
                {noReportsLabel}
              </Stack>
            ),
          }}
        />
      </div>
    </div>
  );
};
